import React, { useState } from 'react';
import UserLessons from './UserLessons';
import UserAttend from './UserAttend';
import { PageContainer, SubTabsBar, SubTab } from './AttendanceReservationStyled';

// 출석/예약 탭의 sub-tab 정의.
// kind 'lesson' → UserLessons + lessonType. 'attend' → UserAttend(입장 내역).
const SUB_TABS = [
  { value: 0, label: '개인레슨', kind: 'lesson', lessonType: 'PRIVATE_LESSON', title: '개인 레슨' },
  { value: 1, label: '그룹레슨', kind: 'lesson', lessonType: 'GROUP_LESSON', title: '그룹 레슨' },
  { value: 2, label: '입장 내역', kind: 'attend' },
  // OT 는 개인레슨과 같은 컬럼 구성(UserLessons.isPrivateLessonTab). value 2 는 기존 진입 링크가 써서 뒤에 붙인다.
  { value: 3, label: 'OT', kind: 'lesson', lessonType: 'OT', title: 'OT' },
];

const AttendanceReservation = ({ user, bigUser, subtab }) => {
  const [activeSubtab, setActiveSubtab] = useState(subtab);
  const handleChange = (_, next) => setActiveSubtab(next);

  // 현재 sub-tab에 맞는 콘텐츠 렌더.
  // key={current.value}: 같은 컴포넌트(UserLessons)라도 type prop이 달라지면
  // 강제 remount해서 내부 state(query.courseClassType)가 새 type으로 초기화되도록 함.
  // (원본 코드는 value === 0/1 분기로 JSX 위치가 달라 자연스럽게 remount되었음)
  const current = SUB_TABS.find(t => t.value === activeSubtab);
  const renderContent = () => {
    if (!current) return null;
    if (current.kind === 'lesson') {
      return (
        <UserLessons
          key={current.value}
          user={user}
          bigUser={bigUser}
          title={current.title}
          type={current.lessonType}
          active
        />
      );
    }
    return <UserAttend key={current.value} user={user} bigUser={bigUser} active />;
  };

  return (
    <PageContainer>
      <SubTabsBar
        value={activeSubtab}
        onChange={handleChange}
        textColor="inherit"
        indicatorColor="secondary"
        variant="fullWidth"
        aria-label="attendance reservation sub tabs">
        {SUB_TABS.map(t => (
          <SubTab key={t.value} value={t.value} label={t.label} />
        ))}
      </SubTabsBar>
      {renderContent()}
    </PageContainer>
  );
};

export default AttendanceReservation;
